import { render, staticRenderFns } from "./GrantRole.vue?vue&type=template&id=3f644353&"
import script from "./GrantRole.vue?vue&type=script&lang=js&"
export * from "./GrantRole.vue?vue&type=script&lang=js&"
import style0 from "./GrantRole.vue?vue&type=style&index=0&id=3f644353&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports